import type SyosController from './SyosController';

class SyosUiContainer {
  syosController?: SyosController;

  $el?: JQuery<any>;

  constructor(syosController: SyosController, containerSelector: string) {
    this.syosController = syosController;
    this.$el = this.syosController?.find(containerSelector);
  }

  on(event: string, handler: { (): void; }) {
    this.syosController?.on(event, handler);
  }

  off(event: string, handler: { (): void; }) {
    this.syosController?.removeListener(event, handler);
  }

  find<T extends HTMLElement>(selector: string): JQuery<T> | undefined {
    return this.$el?.find<T>(selector);
  }

  destroy() {
    this.$el?.off();
    this.$el = undefined;
    this.syosController = undefined;
  }
}

export default SyosUiContainer;
